module.exports = __webpack_public_path__ + "static/media/quickbooks.1bcfa183.svg";